import { type PropsWithChildren, useCallback } from 'react';
import { useActiveRealmAPIContext } from '@interxfi/api-client';
import { type AccessEvaluator, AccessProvider } from '@interxfi/design-system/access-context';

/**
 * Binds the design-system AccessContext to the active realm's access state.
 */
export function WrappedAccessProvider({ children }: PropsWithChildren) {
  const { activeIsReadOnly } = useActiveRealmAPIContext();
  const isAllowed = useCallback<AccessEvaluator>(
    (requirement) => {
      if (requirement.write && activeIsReadOnly !== false) {
        return false;
      }

      // TODO future: match activeScopes to return false for more granular permissions
      return true;
    },
    [activeIsReadOnly],
  );

  return <AccessProvider isAllowed={isAllowed}>{children}</AccessProvider>;
}
